import { useState } from "react"
import { IoIosEye, IoIosEyeOff } from "react-icons/io"

const Input = ({ label, id, className, hide = false, input, error, helperText, ...props }) => {
  const [visibility, setVisibility] = useState(!hide)

  const handleToggle = () => {
    setVisibility((p) => !p)
  }

  const handleMouseDown = (e) => {
    e.preventDefault()
  }

  return (
    <div className="flex flex-col gap-1">
      {label ? (
        <label htmlFor={id} className="text-black text-sm font-medium">
          {label}
        </label>
      ) : null}
      <div className="relative border-none w-full h-[55px]">
        {input ? (
          input
        ) : (
          <input
            type={visibility ? "text" : "password"}
            className={`w-full h-full border ${
              error ? "border-error" : "border-grey hover:border-disabled focus:border-secondary"
            } rounded pl-3 outline-none bg-[transparent] font-['Helvetica'] ${
              hide ? "pr-[40px]" : "pr-3"
            } ${className}`}
            id={id}
            {...props}
          />
        )}
        {hide ? (
          <div className="h-[53px] flex justify-center items-center px-2 absolute top-[1px] right-[1px]">
            {visibility ? (
              <IoIosEyeOff
                size="22px"
                className="text-disabled cursor-pointer"
                onClick={handleToggle}
                onMouseDown={handleMouseDown}
              />
            ) : (
              <IoIosEye
                size="22px"
                className="text-disabled cursor-pointer"
                onClick={handleToggle}
                onMouseDown={handleMouseDown}
              />
            )}
          </div>
        ) : null}
      </div>
      {helperText && !error ? <p className="text-xs text-disabled">{helperText}</p> : null}
      {error ? <p className="text-xs text-error">{error}</p> : null}
    </div>
  )
}

export default Input
